// extracted by css-extract-rspack-plugin
export default {"root":"E1OsxC","disabled":"aEOCvp","cycle":"NRoeQ8"};